import { useContext } from 'react';
import { TealiumContext } from "../providers/TealiumContext.js";
export const useTealium = () => useContext(TealiumContext);